/*
 * Illustrative garment-production sample data for the Platform Demo.
 * Not connected to a live factory. Shape mirrors what a future /api/demo/* or MES endpoint would return.
 */
export const pick = (v, lang) => (v && typeof v === "object" ? v[lang] ?? v.en : v);

export const HOURS = ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17"];

export const LINES = [
  { id: "L1", name: "Line 1", style: "KS-2401 Men's Oxford Shirt", targetHr: 260, outputToday: 1842, targetToday: 1950, wip: 412, dhu: 2.1, operators: 34, bottleneck: { en: "Collar attach (St. 09)", ko: "칼라 부착 (9번 위치)" }, hourly: [212, 248, 256, 262, 128, 244, 258, 234, 0, 0] },
  { id: "L2", name: "Line 2", style: "KS-2319 Women's Blouse", targetHr: 220, outputToday: 1712, targetToday: 1650, wip: 286, dhu: 1.4, operators: 30, bottleneck: { en: "None detected", ko: "감지되지 않음" }, hourly: [206, 224, 231, 236, 118, 228, 233, 236, 0, 0] },
  { id: "L3", name: "Line 3", style: "KS-2419 Men's Oxford Shirt", targetHr: 250, outputToday: 1596, targetToday: 1875, wip: 538, dhu: 3.8, operators: 33, bottleneck: { en: "Sleeve attach (St. 12)", ko: "소매 부착 (12번 위치)" }, hourly: [198, 214, 208, 221, 104, 206, 219, 226, 0, 0] },
  { id: "L4", name: "Line 4", style: "KS-2506 Chino Trouser", targetHr: 180, outputToday: 1318, targetToday: 1350, wip: 244, dhu: 1.9, operators: 28, bottleneck: { en: "Waistband (St. 18)", ko: "허리밴드 (18번 위치)" }, hourly: [160, 172, 178, 181, 86, 174, 180, 187, 0, 0] },
  { id: "L5", name: "Line 5", style: "KS-2512 Polo Knit", targetHr: 300, outputToday: 2264, targetToday: 2250, wip: 318, dhu: 1.2, operators: 36, bottleneck: { en: "None detected", ko: "감지되지 않음" }, hourly: [276, 296, 302, 308, 150, 298, 310, 324, 0, 0] },
  { id: "L6", name: "Line 6", style: "KS-2444 Field Jacket", targetHr: 120, outputToday: 802, targetToday: 900, wip: 196, dhu: 2.7, operators: 38, bottleneck: { en: "Pocket set (St. 21)", ko: "포켓 부착 (21번 위치)" }, hourly: [92, 104, 108, 112, 56, 106, 110, 114, 0, 0] },
];

export const lineEfficiency = (l) => Math.round((l.outputToday / l.targetToday) * 100);

export const STATION = {
  line: "Line 3",
  station: "12",
  operator: { en: "Operator 3-12", ko: "작업자 3-12" },
  operation: { en: "Sleeve attach", ko: "소매 부착" },
  style: "KS-2419 Men's Oxford Shirt",
  color: { en: "White / 40", ko: "화이트 / 40" },
  sam: 1.85,
  targetHr: 42,
  completedToday: 296,
  bundle: { id: "B-3312-07", qty: 24 },
  nextBundles: ["B-3312-08", "B-3312-09", "B-3312-10"],
  steps: [
    { en: "Align sleeve notch to armhole mark", ko: "소매 노치를 암홀 표시에 맞춥니다" },
    { en: "Sew 10 mm seam, 12 SPI, balanced tension", ko: "10mm 시접, 12 SPI, 균형 장력으로 봉제합니다" },
    { en: "Check for puckering at shoulder curve", ko: "어깨 곡선의 퍼커링을 확인합니다" },
    { en: "Bundle and scan complete", ko: "번들을 묶고 완료 스캔합니다" },
  ],
  defects: [
    { id: "skip", k: "demoDefectSkip" },
    { id: "broken", k: "demoDefectBroken" },
    { id: "pucker", k: "demoDefectPucker" },
    { id: "measure", k: "demoDefectMeasure" },
  ],
};

export const ORDERS = [
  { po: "PO-88213", client: { en: "Northline Apparel", ko: "노스라인 어패럴" }, style: "KS-2419 Men's Oxford Shirt", qty: 12000, stages: [100, 64, 41, 22], ship: "2026-10-02", risk: "mid", aql: 97.8, inline: 96.2, final: 98.6, lines: ["L1", "L3"] },
  { po: "PO-88190", client: { en: "Meridian Studio", ko: "메리디안 스튜디오" }, style: "KS-2319 Women's Blouse", qty: 8500, stages: [100, 88, 71, 58], ship: "2026-09-24", risk: "low", aql: 99.1, inline: 98.4, final: 99.3, lines: ["L2"] },
  { po: "PO-88251", client: { en: "Harbor & Co.", ko: "하버 앤 코" }, style: "KS-2506 Chino Trouser", qty: 6000, stages: [100, 52, 30, 12], ship: "2026-10-10", risk: "low", aql: 98.3, inline: 97.5, final: 98.9, lines: ["L4"] },
  { po: "PO-88176", client: { en: "Fieldcraft Outdoor", ko: "필드크래프트 아웃도어" }, style: "KS-2444 Field Jacket", qty: 3200, stages: [100, 46, 18, 4], ship: "2026-09-30", risk: "high", aql: 96.9, inline: 95.1, final: 97.4, lines: ["L6"] },
];

export const ALERTS = [
  { id: 1, line: "L3", level: "high", time: "14:12", text: { en: "Line 3 efficiency below 85% for 2 hours — sleeve attach WIP rising", ko: "3라인 효율 2시간 연속 85% 미만 — 소매 부착 재공 증가" } },
  { id: 2, line: "L6", level: "mid", time: "13:48", text: { en: "Line 6 DHU 2.7 — pocket set rework trending up", ko: "6라인 DHU 2.7 — 포켓 부착 재작업 증가 추세" } },
  { id: 3, line: "L1", level: "mid", time: "13:05", text: { en: "Line 1 collar attach station running 6% below SAM target", ko: "1라인 칼라 부착 위치 표준시간 대비 6% 미달" } },
  { id: 4, line: "L5", level: "low", time: "12:40", text: { en: "Line 5 ahead of plan — 101% of daily target reached", ko: "5라인 계획 초과 — 일일 목표 101% 달성" } },
];
